import { LogoProps } from "@/types";
import logoSrc from "../../maherLogo.png";

interface ExtendedLogoProps extends LogoProps {
  width?: number;
  height?: number;
}

export function Logo({ size = 'md', variant = 'dark', width, height }: ExtendedLogoProps) {
  // Size mapping
  const sizeMap = {
    sm: { width: width || 100, height: height || 33 },
    md: { width: width || 150, height: height || 50 },
    lg: { width: width || 200, height: height || 66 }
  };
  
  const dimensions = sizeMap[size];

  return (
    <img
      src={logoSrc}
      alt="Logo"
      className={`transition-all duration-300`}
      style={{ width: `${dimensions.width}px`, height: `${dimensions.height}px`, objectFit: "contain" }}
    />
  );
}
